import React from 'react';
import { connect } from 'react-redux';
import { ReactComponent as FullCircle } from '../../static/assets/fx-circle-2.svg';
import {PREFIX_URL} from "../../constants";


class ScreenSaver extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = null;
    this.timeoutValue = 1000;
    this.animationDuration = 0;
    this.rotate = 0;
    this.animationDurationInner = 0;
    this.rotateInner = 0;
    this.annimationInnerTimer = null;
    this.animationOuterTimer = null;
  }

  state = {
    isMounted: true,
  }

  componentDidMount() {
    const that = this;
    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
    function loop() {
      const randDuration = Math.floor(Math.random() * (10000 - 1000)) + 1000;
      const rotate = getRandomInt(-180, 180);
      that.setState({ animationDuration: randDuration, rotate: rotate });
      that.animationOuterTimer = setTimeout(function() {
        loop();
      }, randDuration);
    }

    function innerLoop() {
      const animationDurationInner = Math.floor(Math.random() * (2000 - 1000)) + 1000;
      const rotateInner = getRandomInt(-180, 180);
      that.setState({ animationDurationInner: animationDurationInner, rotateInner: rotateInner });
      that.annimationInnerTimer = setTimeout(function() {
        innerLoop();
      }, animationDurationInner);
    }
    loop();
    innerLoop();
    const script = document.createElement("script");
    let scriptSrc = "/js/animated-header.js"
    if (process.env.PUBLIC_URL) {
      scriptSrc = process.env.PUBLIC_URL + scriptSrc;
    }
    script.src = scriptSrc;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  handleItemClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    const id = event.currentTarget.getAttribute('id');
    let newPath;
    if (name === 'start') {
      newPath = PREFIX_URL;
    } else {
        newPath = `${PREFIX_URL}${name}`;
    }
    if (id) {
      this.props.getDataSet(id);
    }
    if (this.props.history.location.pathname !== newPath) {
      this.setState({ isMounted: false });
      clearTimeout(this.annimationInnerTimer);
      clearTimeout(this.animationOuterTimer);
      this.awaitBeforeHistoryPush(newPath, 2000, this.props.history.push);
    }
  }

  awaitBeforeHistoryPush(newPath, time, callback) {
    setTimeout(function() {
      callback(newPath);
    }, time)
  }

  render() {
    return (
      <div className="h-100 w-100 overflow-hidden" name="basic-configuration" onClick={this.handleItemClick}>
        <div id="large-header" className="large-header">
          <canvas className="main-header" id="demo-canvas"></canvas>
        </div>
        <div className={`container-fluid filters-container screen-saver ${this.state.isMounted ? '' : 'unmounting'}`}>
          <div className="main-header-container">
            <h1 className="main-header">
              <span className="header-border header-border-left"></span>
                Process Maturity Matrix
              <span className="header-border header-border-right"></span>
            </h1>
          </div>
          <div className="loader">
            <div className="rotate-outer" style={{transform: `rotate(${this.state.rotate}deg)`, transition: `transform ${this.state.animationDuration * 0.8}ms linear`}}></div>
            <div className="rotate-inner" style={{transform: `rotate(${this.state.rotate * -1}deg)`, transition: `transform ${this.state.animationDuration * 0.8}ms linear`}}></div>
            <FullCircle className="inner-rotation-circle" style={{transform: `rotate(${this.state.rotateInner}deg)`, transition: `transform ${this.state.animationDurationInner * 0.8}ms linear`}} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenSaver);
